import type React from "react";
import { GalleryImageProvider } from "@/components/providers/GalleryImageProvider";
import { GALLERY_MAX_RESULTS, GALLERY_TAG } from "@/lib/consts";
import GalleryCard, { type GalleryCardProperties } from "./gallery-card";

export interface GalleryCardWrapperProperties
  extends Omit<GalleryCardProperties, "tags">,
    React.ComponentPropsWithoutRef<"div"> {
  tags?: string;
  maxResults?: number;
}

function GalleryCardWrapper({
  tags = GALLERY_TAG,
  maxResults = GALLERY_MAX_RESULTS,
  ...props
}: GalleryCardWrapperProperties) {
  return (
    <GalleryImageProvider tags={tags} maxResults={maxResults}>
      <GalleryCard {...props} />
    </GalleryImageProvider>
  );
}

export default GalleryCardWrapper;
